import { z } from "zod";

export const UserSummary = z.object({
  id: z.string(),
  username: z.string(),
  email: z.string().optional(),
  role: z.enum(["admin", "editor", "user"]),
  createdAt: z.string(),
});
export type UserSummary = z.infer<typeof UserSummary>;

export const MeResponse = z.object({
  user: UserSummary,
  csrfToken: z.string().optional(),
});

export const MyCatalog = z.object({
  id: z.string(),
  name: z.string(),
  label: z.string(),
  perm: z.enum(["read", "write", "admin"]),
});
export type MyCatalog = z.infer<typeof MyCatalog>;

export const DocumentListItem = z
  .object({
    id: z.string(),
    slug: z.string(),
    title: z.string().optional(),
    category: z.string().optional(),
    description: z.string().optional(),
    updatedAt: z.string().optional(),
    contentType: z.string().optional(),
  })
  .passthrough();
export type DocumentListItem = z.infer<typeof DocumentListItem>;

export const DocumentListResponse = z.object({
  data: z.array(DocumentListItem),
  pagination: z
    .object({
      limit: z.number().optional(),
      offset: z.number().optional(),
      total: z.number().optional(),
      nextOffset: z.number().optional(),
    })
    .partial()
    .optional(),
});

export const DocumentLine = z.object({
  n: z.number(),
  text: z.string(),
  matched: z.boolean().optional(),
});

export const DocumentReadResponse = z.object({
  document: z.object({
    id: z.string(),
    slug: z.string(),
    title: z.string().optional(),
    category: z.string().optional(),
    description: z.string().optional(),
  }),
  revision: z
    .object({
      id: z.string(),
      title: z.string().optional(),
      url: z.string().optional(),
      contentType: z.string().optional(),
      catalogId: z.string().optional(),
      documentId: z.string().optional(),
      createdAt: z.string().optional(),
    })
    .passthrough(),
  lines: z.array(DocumentLine),
  truncated: z.boolean(),
  bytesReturned: z.number(),
  totalBytes: z.number(),
  nextOffset: z.number().optional(),
});
export type DocumentReadResponse = z.infer<typeof DocumentReadResponse>;
